// extracted by mini-css-extract-plugin
module.exports = {"Chart":"styles_Chart__1_vrq","ChartFilter":"styles_ChartFilter__3Vp1L","Loader":"styles_Loader__Tre-B","Loader01":"styles_Loader01__3OO92"};